import { render, staticRenderFns } from "./ModulesConfig.vue?vue&type=template&id=b0caa586&scoped=true"
import script from "./ModulesConfig.vue?vue&type=script&lang=ts"
export * from "./ModulesConfig.vue?vue&type=script&lang=ts"
import style0 from "./ModulesConfig.vue?vue&type=style&index=0&id=b0caa586&prod&lang=less"
import style1 from "./ModulesConfig.vue?vue&type=style&index=1&id=b0caa586&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0caa586",
  null
  
)

export default component.exports